import React, { Fragment } from "react";
import { Separator } from "@wdpr/groot-components";
import Item from "./Item";
import { arrayIsEmpty } from "utils";
import { txpMotionDelayMs } from "config-txp";

const ROOM_CATEGORY = "room";

const CompositeItem = ({
	category,
	title,
	items,
	separateItems = false,
	separateTitle = true,
	animationClasses,
	isTxp = false,
}) => {
	const mainClass = "syndicated-section__content__composite";
	let classes = mainClass;
	if (category) classes += ` ${mainClass}--${category}`;

	if (arrayIsEmpty(items)) return null;

	const isVacationOffer = isTxp && category === "vacationoffer";
	const roomItems = isVacationOffer
		? items.filter((item) => item.category === ROOM_CATEGORY)
		: [];
	const nonRoomItems = isVacationOffer
		? items.filter((item) => item.category !== ROOM_CATEGORY)
		: [];
	const nonRoomLabel = nonRoomItems.map((item) => item.content).join(" ");

	return (
		<div className={classes}>
			{title ? (
				<div
					className={`${mainClass}__title ${
						isTxp ? animationClasses ?? "" : ""
					}`}
				>
					{title}
				</div>
			) : (
				separateTitle && !isTxp && <Separator />
			)}
			<div
				className={
					isTxp
						? isVacationOffer
							? `${animationClasses} ${mainClass}--vacation-offer`
							: `${animationClasses}`
						: ""
				}
				style={
					isTxp ? { animationDelay: `${txpMotionDelayMs.tiny}ms` } : undefined
				}
			>
				{isVacationOffer ? (
					<>
						{roomItems.map((item, key) => (
							<div key={key} className={animationClasses}>
								<Item
									{...item}
									animationClasses={animationClasses}
									style={{ animationDelay: `${txpMotionDelayMs.tiny}ms` }}
								/>
							</div>
						))}
						{nonRoomLabel && (
							<Item
								category={`no-${ROOM_CATEGORY}`}
								title=""
								content={nonRoomLabel}
								animationClasses={animationClasses}
								style={{ animationDelay: `${txpMotionDelayMs.tiny}ms` }}
							/>
						)}
					</>
				) : (
					items.map((item, key) => (
						<Fragment key={key}>
							<div>
								<Item {...item} />
								{separateItems && <Separator />}
							</div>
						</Fragment>
					))
				)}
			</div>
		</div>
	);
};

export default CompositeItem;
